import getExperienceTags from '../../../../../Piano/modules/get-experience-tags'
import options from '../../../../../../config/options.json'
import userSession from '../../../../../../topics/Profile/modules/user-session'
import onInitPiano from '../../../../../Piano/modules/on-init-piano'
import isServerSide from '../../../../../../modules/is-server-side'

const setContextOutbrain = () => {
  onInitPiano(() => {
    let context = []
    const userData = userSession.getData() || {}
    const experienceTags = getExperienceTags() || []
    if (experienceTags.includes(options.Plus.tag)) context.push('plusContent')
    if (userData.hasSubscription) context.push('plusUser')
    if (!isServerSide()) window.OB_ContextKeyValue = context.join(',')
  })
}

export default setContextOutbrain
